import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import { Badge } from '../apiReference/util';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { useCallback } from 'react';
import { searchResultBadgeIsApiEndpoint } from './searchHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const ResultIcon = ({
  badge
}) => {
  const renderDesktop = useCallback(() => {
    if (searchResultBadgeIsApiEndpoint(badge)) {
      return /*#__PURE__*/_jsx(Badge, {
        use: badge,
        children: badge.toLowerCase() === 'delete' ? 'DEL' : badge.toUpperCase()
      });
    }
    return /*#__PURE__*/_jsx(UIIcon, {
      name: badge === 'API_AND_REFERENCE' ? 'code' : 'bulb',
      size: 30,
      color: EERIE,
      screenReaderText: badge === 'API_AND_REFERENCE' ? 'API and Reference' : 'Guide' // todo, localize
    });
  }, [badge]);
  const renderMobile = useCallback(() => null, []);
  return /*#__PURE__*/_jsx(ResponsiveRenderer, {
    renderDesktop: renderDesktop,
    renderMobile: renderMobile
  });
};